import { Quill } from 'vue-quill-editor';
import { ClassicFonts } from '../../lib/constants';

const font = Quill.import('formats/font');
font.whitelist = ClassicFonts.map(x => x.value);

export const fonts = font;

const size = Quill.import('attributors/class/size');
size.whitelist = [
  'small',
  'large',
  'huge',
  '12',
  '16',
  '20',
  '24',
  '32',
  '40',
  '48',
  '56',
  '64',
  '72',
  '80',
  '90',
  '100',
  '120',
  '140'
];

export const sizes = size;
